<template>
  <main class="e-dialog__body">
    <div class="e-dialog__content">
      <div v-html="data.body"></div>
      <div v-if="addendum" v-html="addendum"></div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'DialogItemBody',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    addendum: {
      type: String,
    }
  },
}
</script>
